export type SignalRMessageFilter = (data: { [key: string]: any }) => boolean;

export function fieldNonexistentOrMatchingFilter(fieldName: string, fieldValue: any): SignalRMessageFilter {
  return message => !(fieldName in message) || message[fieldName] === fieldValue;
}
